<template>
  <div class="room dehumidifier-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-multi-line">
        <div class="column-line-1-1">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop1" :bold="true" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop11" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop10" :series="switchDataTop10" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop11" :series="switchDataTop11" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop12" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop12" :series="switchDataTop12" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop13" :series="switchDataTop13" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop13" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop14" :series="switchDataTop14" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop15" :series="switchDataTop15" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop14" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop16" :series="switchDataTop16" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop17" :series="switchDataTop17" />
        </div>
        <div class="column-line-1-2">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown2A" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleDown20" :series="switchDataDown20" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown21" :series="switchDataDown21" />
          <SwitchStatus class="switch-item" :title="switchTitleDown22" :series="switchDataDown22" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown23" :series="switchDataDown23" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-2-1">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop2" :bold="true" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop21" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop20" :series="switchDataTop20" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop22" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop21" :series="switchDataTop21" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop22" :series="switchDataTop22" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop23" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop23" :series="switchDataTop23" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop24" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop24" :series="switchDataTop24" />
        </div>
        <div class="column-line-2-2">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown2B" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleDown30" :series="switchDataDown30" />
          <SwitchStatus class="switch-item" :title="switchTitleDown31" :series="switchDataDown31" />
          <SwitchStatus class="switch-item" :title="switchTitleDown24" :series="switchDataDown24" />
          <SwitchStatus class="switch-item" :title="switchTitleDown25" :series="switchDataDown25" />
          <SwitchStatus class="switch-item" :title="switchTitleDown26" :series="switchDataDown26" />
          <SwitchStatus class="switch-item" :title="switchTitleDown27" :series="switchDataDown27" />
          <SwitchStatus class="switch-item" :title="switchTitleDown28" :series="switchDataDown28" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-3-1">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop3" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop31" :series="switchDataTop31" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop32" :series="switchDataTop32" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop33" :series="switchDataTop33" />
          <SwitchStatus class="switch-item" :title="switchTitleTop34" :series="switchDataTop34" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop35" :series="switchDataTop35" />
          <SwitchStatus class="switch-item" :title="switchTitleTop36" :series="switchDataTop36" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop37" :series="switchDataTop37" />
          <SwitchStatus class="switch-item" :title="switchTitleTop38" :series="switchDataTop38" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop39" :series="switchDataTop39" />
        </div>
        <div class="column-line-3-2">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop42" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop49" :series="switchDataTop49" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop410" :series="switchDataTop410" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop411" :series="switchDataTop411" />
          <SwitchStatus class="switch-item" :title="switchTitleTop412" :series="switchDataTop412" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop413" :series="switchDataTop413" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop414" :series="switchDataTop414" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-4-1">
          <!-- <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" /> -->
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop41" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop41" :series="switchDataTop41" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop42" :series="switchDataTop42" />
          <SwitchStatus class="switch-item" :title="switchTitleTop43" :series="switchDataTop43" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop44" :series="switchDataTop44" />
          <SwitchStatus class="switch-item" :title="switchTitleTop45" :series="switchDataTop45" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop46" :series="switchDataTop46" />
          <SwitchStatus class="switch-item" :title="switchTitleTop47" :series="switchDataTop47" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop48" :series="switchDataTop48" />
        </div>
        <div class="column-line-4-2">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop43" :bold="true" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop43A" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop415" :series="switchDataTop415" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop416" :series="switchDataTop416" />
          <SwitchStatusTitle class="switch-item-sub-title" :title="columnTitleTop43B" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop417" :series="switchDataTop417" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop418" :series="switchDataTop418" />
        </div>
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>

<script>
import configJson from "./config/station.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      stationName: "",
      stationIndex: "",
      stationVentNameFix: "",

      exitGasClampListDict: {
        "1出口": ["A1", "A2"],
      },

      switchDataTop10: null,
      switchDataTop11: null,
      switchDataTop12: null,
      switchDataTop13: null,
      switchDataTop14: null,
      switchDataTop15: null,
      switchDataTop16: null,
      switchDataTop17: null,

      switchDataTop20: null,
      switchDataTop21: null,
      switchDataTop22: null,
      switchDataTop23: null,
      switchDataTop24: null,

      switchDataDown20: null,
      switchDataDown21: null,
      switchDataDown22: null,
      switchDataDown23: null,
      switchDataDown24: null,
      switchDataDown25: null,
      switchDataDown26: null,
      switchDataDown27: null,
      switchDataDown28: null,

      switchDataTop31: null,
      switchDataTop32: null,
      switchDataTop33: null,
      switchDataTop34: null,
      switchDataTop35: null,
      switchDataTop36: null,
      switchDataTop37: null,
      switchDataTop38: null,
      switchDataTop39: null,

      switchDataDown30: null,
      switchDataDown31: null,

      switchDataTop41: null,
      switchDataTop42: null,
      switchDataTop43: null,
      switchDataTop44: null,
      switchDataTop45: null,
      switchDataTop46: null,
      switchDataTop47: null,
      switchDataTop48: null,
      switchDataTop49: null,
      switchDataTop410: null,
      switchDataTop411: null,
      switchDataTop412: null,
      switchDataTop413: null,
      switchDataTop414: null,
      switchDataTop415: null,
      switchDataTop416: null,
      switchDataTop417: null,
      switchDataTop418: null,


      deviceList: [],
    };
  },
  computed: {
    columnTitleTop1: function () {
      return this.stationName + "-管道温湿度";
    },
    columnTitleTop11: function () {
      return "管道1";
    },
    columnTitleTop12: function () {
      return "管道2";
    },
    columnTitleTop13: function () {
      return "管道3";
    },
    columnTitleTop14: function () {
      return "管道4";
    },

    columnTitleTop2: function () {
      return this.stationName + "-其他温湿度";
    },
    columnTitleTop21: function () {
      return "新风";
    },
    columnTitleTop22: function () {
      return "制冷";
    },
    columnTitleTop23: function () {
      return "转轮";
    },
    columnTitleTop24: function () {
      return "设定";
    },

    columnTitleDown2A: function () {
      return this.stationName + "-运行状态";
    },
    columnTitleDown2B: function () {
      return this.stationName + "-其他状态";
    },

    columnTitleTop3: function () {
      return this.stationName + "-再生加热";
    },
    columnTitleDown3: function () {
      return this.stationName + "-阀门";
    },

    columnTitleTop4: function () {
      return this.stationName + "-风机";
    },
    columnTitleTop41: function () {
      return this.stationName + "-高压风机";
    },
    columnTitleTop42: function () {
      return this.stationName + "-散热风机";
    },
    columnTitleTop43: function () {
      return this.stationName + "-其他风机";
    },
    columnTitleTop43A: function () {
      return "处理风机";
    },
    columnTitleTop43B: function () {
      return "再生风机";
    },

    columnTitleDown4: function () {
      return this.stationName + "-表冷段";
    },

    switchTitleTop10: function () {
      return "管道1";
    },
    switchTitleTop11: function () {
      return "管道1";
    },
    switchTitleTop12: function () {
      return "管道2";
    },
    switchTitleTop13: function () {
      return "管道2";
    },
    switchTitleTop14: function () {
      return "管道3";
    },
    switchTitleTop15: function () {
      return "管道3";
    },
    switchTitleTop16: function () {
      return "管道4";
    },
    switchTitleTop17: function () {
      return "管道4";
    },

    switchTitleTop20: function () {
      return "新风";
    },
    switchTitleTop21: function () {
      return "前冷";
    },
    switchTitleTop22: function () {
      return "中冷";
    },
    switchTitleTop23: function () {
      return "转轮后";
    },
    switchTitleTop23: function () {
      return "转轮后";
    },
    switchTitleTop24: function () {
      return "湿度设定";
    },

    switchTitleDown20: function () {
      return "除湿机";
    },
    switchTitleDown21: function () {
      return "除湿机";
    },
    switchTitleDown22: function () {
      return "转轮电机";
    },
    switchTitleDown23: function () {
      return "转轮电机";
    },
    switchTitleDown24: function () {
      return "接近开关";
    },
    switchTitleDown25: function () {
      return "急停";
    },
    switchTitleDown26: function () {
      return "温控开关";
    },
    switchTitleDown27: function () {
      return "手动模式";
    },
    switchTitleDown28: function () {
      return "自动模式";
    },

    switchTitleTop31: function () {
      return "再生加热";
    },
    switchTitleTop32: function () {
      return "再生加热1上限";
    },
    switchTitleTop33: function () {
      return "再生加热2上限";
    },
    switchTitleTop34: function () {
      return "再生加热1";
    },
    switchTitleTop35: function () {
      return "再生加热1";
    },
    switchTitleTop36: function () {
      return "再生加热2";
    },
    switchTitleTop37: function () {
      return "再生加热2";
    },
    switchTitleTop38: function () {
      return "再生加热3";
    },
    switchTitleTop39: function () {
      return "再生加热3";
    },

    switchTitleDown30: function () {
      return "电动阀门1-1/1-2";
    },
    switchTitleDown31: function () {
      return "电动阀门1-3/1-4";
    },

    switchTitleTop41: function () {
      return "高压风机1";
    },
    switchTitleTop42: function () {
      return "高压风机1";
    },
    switchTitleTop43: function () {
      return "高压风机2";
    },
    switchTitleTop44: function () {
      return "高压风机2";
    },
    switchTitleTop45: function () {
      return "高压风机3";
    },
    switchTitleTop46: function () {
      return "高压风机3";
    },
    switchTitleTop47: function () {
      return "高压风机4";
    },
    switchTitleTop48: function () {
      return "高压风机4";
    },

    switchTitleTop49: function () {
      return "散热风机1";
    },
    switchTitleTop410: function () {
      return "散热风机1";
    },
    switchTitleTop411: function () {
      return "散热风机1启动";
    },
    switchTitleTop412: function () {
      return "散热风机2";
    },
    switchTitleTop413: function () {
      return "散热风机2";
    },
    switchTitleTop414: function () {
      return "散热风机2启动";
    },
    switchTitleTop415: function () {
      return "处理风机";
    },
    switchTitleTop416: function () {
      return "处理风机";
    },
    switchTitleTop417: function () {
      return "再生风机";
    },
    switchTitleTop418: function () {
      return "再生风机";
    },

    switchTitleDown41: function () {
      return "前表";
    },
    switchTitleDown42: function () {
      return "前表盘管";
    },
    switchTitleDown43: function () {
      return "前表设定";
    },
    switchTitleDown44: function () {
      return "前表";
    },
    switchTitleDown45: function () {
      return "前表化霜";
    },
    switchTitleDown46: function () {
      return "前表保护";
    },
    // switchTitleDown47: function () {
    //   return "前表高压";
    // },
    switchTitleDown48: function () {
      return "前表";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    assembleExitGasClamp(exitName) {
      let gasClampName = "";
      if (exitName && this.exitGasClampListDict[exitName]) {
        let gasClampList = this.exitGasClampListDict[exitName];
        for (let gasClamp of gasClampList) {
          if (gasClampName !== "") {
            gasClampName += ", ";
          }
          gasClampName += gasClamp;
        }
      }

      let result = exitName + "连接气夹: " + gasClampName;
      return result;
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationId = configJson[routerName].stationId;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      // this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        const switchIdTop10T = this.findDeviceId(this.switchTitleTop10 + "温度");
        const switchIdTop10H = this.findDeviceId(this.switchTitleTop10 + "湿度");
        const switchIdTop10A = this.findDeviceId(this.switchTitleTop10 + "含湿量");
        const switchIdTop11P = this.findDeviceId(this.switchTitleTop11 + "压力");
        const switchIdTop11F = this.findDeviceId(this.switchTitleTop11 + "风速");
        const switchIdTop12T = this.findDeviceId(this.switchTitleTop12 + "温度");
        const switchIdTop12H = this.findDeviceId(this.switchTitleTop12 + "湿度");
        const switchIdTop12A = this.findDeviceId(this.switchTitleTop12 + "含湿量");
        const switchIdTop13P = this.findDeviceId(this.switchTitleTop13 + "压力");
        const switchIdTop13F = this.findDeviceId(this.switchTitleTop13 + "风速");
        const switchIdTop14T = this.findDeviceId(this.switchTitleTop14 + "温度");
        const switchIdTop14H = this.findDeviceId(this.switchTitleTop14 + "湿度");
        const switchIdTop14A = this.findDeviceId(this.switchTitleTop14 + "含湿量");
        const switchIdTop15P = this.findDeviceId(this.switchTitleTop15 + "压力");
        const switchIdTop15F = this.findDeviceId(this.switchTitleTop15 + "风速");
        const switchIdTop16T = this.findDeviceId(this.switchTitleTop16 + "温度");
        const switchIdTop16H = this.findDeviceId(this.switchTitleTop16 + "湿度");
        const switchIdTop16A = this.findDeviceId(this.switchTitleTop16 + "含湿量");
        const switchIdTop17P = this.findDeviceId(this.switchTitleTop17 + "压力");
        const switchIdTop17F = this.findDeviceId(this.switchTitleTop17 + "风速");

        this.switchDataTop10 = [
          {
            data: currentData[switchIdTop10T].value,
            isError: currentData[switchIdTop10T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop10H].value,
            isError: currentData[switchIdTop10H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop10A].value,
            isError: currentData[switchIdTop10A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop11 = [
          {
            data: currentData[switchIdTop11P].value,
            isError: currentData[switchIdTop11P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop11F].value,
            isError: currentData[switchIdTop11F].errorLevel,
            unit: "m/s",
          },
        ];
        this.switchDataTop12 = [
          {
            data: currentData[switchIdTop12T].value,
            isError: currentData[switchIdTop12T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop12H].value,
            isError: currentData[switchIdTop12H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop12A].value,
            isError: currentData[switchIdTop12A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop13 = [
          {
            data: currentData[switchIdTop13P].value,
            isError: currentData[switchIdTop13P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop13F].value,
            isError: currentData[switchIdTop13F].errorLevel,
            unit: "m/s",
          },
        ];
        this.switchDataTop14 = [
          {
            data: currentData[switchIdTop14T].value,
            isError: currentData[switchIdTop14T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop14H].value,
            isError: currentData[switchIdTop14H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop14A].value,
            isError: currentData[switchIdTop14A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop15 = [
          {
            data: currentData[switchIdTop15P].value,
            isError: currentData[switchIdTop15P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop15F].value,
            isError: currentData[switchIdTop15F].errorLevel,
            unit: "m/s",
          },
        ];
        this.switchDataTop16 = [
          {
            data: currentData[switchIdTop16T].value,
            isError: currentData[switchIdTop16T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop16H].value,
            isError: currentData[switchIdTop16H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop16A].value,
            isError: currentData[switchIdTop16A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop17 = [
          {
            data: currentData[switchIdTop17P].value,
            isError: currentData[switchIdTop17P].errorLevel,
            unit: "KPa",
          },
          {
            data: currentData[switchIdTop17F].value,
            isError: currentData[switchIdTop17F].errorLevel,
            unit: "m/s",
          },
        ];

        const switchIdTop20T = this.findDeviceId(this.switchTitleTop20 + "温度");
        const switchIdTop20H = this.findDeviceId(this.switchTitleTop20 + "湿度");
        const switchIdTop20A = this.findDeviceId(this.switchTitleTop20 + "含湿量");
        const switchIdTop21T = this.findDeviceId(this.switchTitleTop21 + "温度");
        const switchIdTop22T = this.findDeviceId(this.switchTitleTop22 + "温度");
        const switchIdTop22H = this.findDeviceId(this.switchTitleTop22 + "湿度");
        const switchIdTop22A = this.findDeviceId(this.switchTitleTop22 + "含湿量");
        const switchIdTop23T = this.findDeviceId(this.switchTitleTop23 + "温度");
        const switchIdTop24A = this.findDeviceId(this.switchTitleTop24 + "下限");
        const switchIdTop24B = this.findDeviceId(this.switchTitleTop24 + "上限");

        this.switchDataTop20 = [
          {
            data: currentData[switchIdTop20T].value,
            isError: currentData[switchIdTop20T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop20H].value,
            isError: currentData[switchIdTop20H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop20A].value,
            isError: currentData[switchIdTop20A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop21 = {
          data: currentData[switchIdTop21T].value,
          isError: currentData[switchIdTop21T].errorLevel,
          unit: "℃",
        };
        this.switchDataTop22 = [
          {
            data: currentData[switchIdTop22T].value,
            isError: currentData[switchIdTop22T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop22H].value,
            isError: currentData[switchIdTop22H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop22A].value,
            isError: currentData[switchIdTop22A].errorLevel,
            unit: "g/kg",
          },
        ];
        this.switchDataTop23 = {
          data: currentData[switchIdTop23T].value,
          isError: currentData[switchIdTop23T].errorLevel,
          unit: "℃",
        };
        this.switchDataTop24 = [
          {
            data: currentData[switchIdTop24A].value,
            isError: currentData[switchIdTop24A].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop24B].value,
            isError: currentData[switchIdTop24B].errorLevel,
            unit: "%",
          },
        ];

        const switchIdDown20R = this.findDeviceId(this.switchTitleDown20 + "运行");
        const switchIdDown20M = this.findDeviceId(this.switchTitleDown20 + "故障");
        const switchIdDown21 = this.findDeviceId(this.switchTitleDown21 + "运行时间");
        const switchIdDown22R = this.findDeviceId(this.switchTitleDown22 + "和再生风机运行");
        const switchIdDown22M = this.findDeviceId(this.switchTitleDown22 + "故障");
        const switchIdDown23 = this.findDeviceId(this.switchTitleDown23 + "和再生风机运行时间");
        const switchIdDown24 = this.findDeviceId(this.switchTitleDown24);
        const switchIdDown25 = this.findDeviceId(this.switchTitleDown25);
        const switchIdDown26 = this.findDeviceId(this.switchTitleDown26 + "报警");
        const switchIdDown27 = this.findDeviceId(this.switchTitleDown27);
        const switchIdDown28 = this.findDeviceId(this.switchTitleDown28);

        this.switchDataDown20 = [
          {
            data: currentData[switchIdDown20R].value,
            isError: currentData[switchIdDown20R].errorLevel,
          },
          {
            data: currentData[switchIdDown20M].value,
            isError: currentData[switchIdDown20M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataDown21 = {
          data: currentData[switchIdDown21].value,
          isError: currentData[switchIdDown21].errorLevel,
          isRunningTime: true,
        };
        this.switchDataDown22 = [
          {
            data: currentData[switchIdDown22R].value,
            isError: currentData[switchIdDown22R].errorLevel,
          },
          {
            data: currentData[switchIdDown22M].value,
            isError: currentData[switchIdDown22M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataDown23 = {
          data: currentData[switchIdDown23].value,
          isError: currentData[switchIdDown23].errorLevel,
          isRunningTime: true,
        };
        this.switchDataDown24 = {
          data: currentData[switchIdDown24].value,
          isError: currentData[switchIdDown24].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };
        this.switchDataDown25 = {
          data: currentData[switchIdDown25].value,
          isError: currentData[switchIdDown25].errorLevel,
          textOn: "报警",
          textOff: "否",
          isZh: true,
        };
        this.switchDataDown26 = {
          data: currentData[switchIdDown26].value,
          isError: currentData[switchIdDown26].errorLevel,
          textOn: "报警",
          textOff: "正常",
          isZh: true,
        };
        this.switchDataDown27 = {
          data: currentData[switchIdDown27].value,
          isError: currentData[switchIdDown27].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };
        this.switchDataDown28 = {
          data: currentData[switchIdDown28].value,
          isError: currentData[switchIdDown28].errorLevel,
          textOn: "开启",
          textOff: "关闭",
        };

        const switchIdTop31 = this.findDeviceId(this.switchTitleTop31 + "温度");
        const switchIdTop32 = this.findDeviceId(this.switchTitleTop32.replace("上限", "温度上限"));
        const switchIdTop33 = this.findDeviceId(this.switchTitleTop33.replace("上限", "温度上限"));
        const switchIdTop34R = this.findDeviceId(this.switchTitleTop34 + "运行");
        const switchIdTop34M = this.findDeviceId(this.switchTitleTop34 + "故障");
        const switchIdTop35 = this.findDeviceId(this.switchTitleTop35 + "运行时间");
        const switchIdTop36R = this.findDeviceId(this.switchTitleTop36 + "运行");
        const switchIdTop36M = this.findDeviceId(this.switchTitleTop36 + "故障");
        const switchIdTop37 = this.findDeviceId(this.switchTitleTop37 + "运行时间");
        const switchIdTop38R = this.findDeviceId(this.switchTitleTop38 + "运行");
        const switchIdTop38M = this.findDeviceId(this.switchTitleTop38 + "故障");
        const switchIdTop39 = this.findDeviceId(this.switchTitleTop39 + "运行时间");

        this.switchDataTop31 = {
          data: currentData[switchIdTop31].value,
          isError: currentData[switchIdTop31].errorLevel,
          unit: "℃",
        };
        this.switchDataTop32 = {
          data: currentData[switchIdTop32].value,
          isError: currentData[switchIdTop32].errorLevel,
          unit: "℃",
        };
        this.switchDataTop33 = {
          data: currentData[switchIdTop33].value,
          isError: currentData[switchIdTop33].errorLevel,
          unit: "℃",
        };

        this.switchDataTop34 = [
          {
            data: currentData[switchIdTop34R].value,
            isError: currentData[switchIdTop34R].errorLevel,
          },
          {
            data: currentData[switchIdTop34M].value,
            isError: currentData[switchIdTop34M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop35 = {
          data: currentData[switchIdTop35].value,
          isError: currentData[switchIdTop35].errorLevel,
          isRunningTime: true,
        };

        this.switchDataTop36 = [
          {
            data: currentData[switchIdTop36R].value,
            isError: currentData[switchIdTop36R].errorLevel,
          },
          {
            data: currentData[switchIdTop36M].value,
            isError: currentData[switchIdTop36M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop37 = {
          data: currentData[switchIdTop37].value,
          isError: currentData[switchIdTop37].errorLevel,
          isRunningTime: true,
        };

        this.switchDataTop38 = [
          {
            data: currentData[switchIdTop38R].value,
            isError: currentData[switchIdTop38R].errorLevel,
          },
          {
            data: currentData[switchIdTop38M].value,
            isError: currentData[switchIdTop38M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop39 = {
          data: currentData[switchIdTop39].value,
          isError: currentData[switchIdTop39].errorLevel,
          isRunningTime: true,
        };

        const switchIdDown30A = this.findDeviceId(this.switchTitleDown30.replace("1-1/1-2", "1-1"));
        const switchIdDown30B = this.findDeviceId(this.switchTitleDown30.replace("1-1/1-2", "1-2"));
        const switchIdDown31A = this.findDeviceId(this.switchTitleDown31.replace("1-3/1-4", "1-3"));
        const switchIdDown31B = this.findDeviceId(this.switchTitleDown31.replace("1-3/1-4", "1-4"));
        this.switchDataDown30 = [
          {
            data: currentData[switchIdDown30A].value,
            isError: currentData[switchIdDown30A].errorLevel,
            textOn: "开启",
            textOff: "关闭",
          },
          {
            data: currentData[switchIdDown30B].value,
            isError: currentData[switchIdDown30B].errorLevel,
            textOn: "开启",
            textOff: "关闭",
          },
        ];
        this.switchDataDown31 = [
          {
            data: currentData[switchIdDown31A].value,
            isError: currentData[switchIdDown31A].errorLevel,
            textOn: "开启",
            textOff: "关闭",
          },
          {
            data: currentData[switchIdDown31B].value,
            isError: currentData[switchIdDown31B].errorLevel,
            textOn: "开启",
            textOff: "关闭",
          },
        ];

        const switchIdTop41R = this.findDeviceId(this.switchTitleTop41 + "运行");
        const switchIdTop41M = this.findDeviceId(this.switchTitleTop41 + "故障");
        const switchIdTop42 = this.findDeviceId(this.switchTitleTop42 + "运行时间");
        const switchIdTop43R = this.findDeviceId(this.switchTitleTop43 + "运行");
        const switchIdTop43M = this.findDeviceId(this.switchTitleTop43 + "故障");
        const switchIdTop44 = this.findDeviceId(this.switchTitleTop44 + "运行时间");
        const switchIdTop45R = this.findDeviceId(this.switchTitleTop45 + "运行");
        const switchIdTop45M = this.findDeviceId(this.switchTitleTop45 + "故障");
        const switchIdTop46 = this.findDeviceId(this.switchTitleTop46 + "运行时间");
        const switchIdTop47R = this.findDeviceId(this.switchTitleTop47 + "运行");
        const switchIdTop47M = this.findDeviceId(this.switchTitleTop47 + "故障");
        const switchIdTop48 = this.findDeviceId(this.switchTitleTop48 + "运行时间");
        const switchIdTop49R = this.findDeviceId(this.switchTitleTop49 + "运行");
        const switchIdTop49M = this.findDeviceId(this.switchTitleTop49.replace("1", "故障"));
        const switchIdTop410 = this.findDeviceId(this.switchTitleTop410 + "运行时间");
        const switchIdTop411 = this.findDeviceId(this.switchTitleTop411 + "温度");
        const switchIdTop412R = this.findDeviceId(this.switchTitleTop412 + "运行");
        const switchIdTop412M = this.findDeviceId(this.switchTitleTop412.replace("2", "故障"));
        const switchIdTop413 = this.findDeviceId(this.switchTitleTop413 + "运行时间");
        const switchIdTop414 = this.findDeviceId(this.switchTitleTop414 + "温度");
        const switchIdTop415R = this.findDeviceId(this.switchTitleTop415 + "运行");
        const switchIdTop415M = this.findDeviceId(this.switchTitleTop415 + "故障");
        const switchIdTop416 = this.findDeviceId(this.switchTitleTop416 + "运行时间");
        const switchIdTop417R = this.findDeviceId("转轮电机和" + this.switchTitleTop417 + "运行");
        const switchIdTop417M = this.findDeviceId(this.switchTitleTop417 + "故障");
        const switchIdTop418 = this.findDeviceId("转轮电机和" + this.switchTitleTop418 + "运行时间");

        this.switchDataTop41 = [
          {
            data: currentData[switchIdTop41R].value,
            isError: currentData[switchIdTop41R].errorLevel,
          },
          {
            data: currentData[switchIdTop41M].value,
            isError: currentData[switchIdTop41M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop42 = {
          data: currentData[switchIdTop42].value,
          isError: currentData[switchIdTop42].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop43 = [
          {
            data: currentData[switchIdTop43R].value,
            isError: currentData[switchIdTop43R].errorLevel,
          },
          {
            data: currentData[switchIdTop43M].value,
            isError: currentData[switchIdTop43M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop44 = {
          data: currentData[switchIdTop44].value,
          isError: currentData[switchIdTop44].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop45 = [
          {
            data: currentData[switchIdTop45R].value,
            isError: currentData[switchIdTop45R].errorLevel,
          },
          {
            data: currentData[switchIdTop45M].value,
            isError: currentData[switchIdTop45M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop46 = {
          data: currentData[switchIdTop46].value,
          isError: currentData[switchIdTop46].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop47 = [
          {
            data: currentData[switchIdTop47R].value,
            isError: currentData[switchIdTop47R].errorLevel,
          },
          {
            data: currentData[switchIdTop47M].value,
            isError: currentData[switchIdTop47M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop48 = {
          data: currentData[switchIdTop48].value,
          isError: currentData[switchIdTop48].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop49 = [
          {
            data: currentData[switchIdTop49R].value,
            isError: currentData[switchIdTop49R].errorLevel,
          },
          {
            data: currentData[switchIdTop49M].value,
            isError: currentData[switchIdTop49M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop410 = {
          data: currentData[switchIdTop410].value,
          isError: currentData[switchIdTop410].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop411 = {
          data: currentData[switchIdTop411].value,
          isError: currentData[switchIdTop411].errorLevel,
          unit: "℃",
        };
        this.switchDataTop412 = [
          {
            data: currentData[switchIdTop412R].value,
            isError: currentData[switchIdTop412R].errorLevel,
          },
          {
            data: currentData[switchIdTop412M].value,
            isError: currentData[switchIdTop412M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop413 = {
          data: currentData[switchIdTop413].value,
          isError: currentData[switchIdTop413].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop414 = {
          data: currentData[switchIdTop414].value,
          isError: currentData[switchIdTop414].errorLevel,
          unit: "℃",
        };
        this.switchDataTop415 = [
          {
            data: currentData[switchIdTop415R].value,
            isError: currentData[switchIdTop415R].errorLevel,
          },
          {
            data: currentData[switchIdTop415M].value,
            isError: currentData[switchIdTop415M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop416 = {
          data: currentData[switchIdTop416].value,
          isError: currentData[switchIdTop416].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop417 = [
          {
            data: currentData[switchIdTop417R].value,
            isError: currentData[switchIdTop417R].errorLevel,
          },
          {
            data: currentData[switchIdTop417M].value,
            isError: currentData[switchIdTop417M].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataTop418 = {
          data: currentData[switchIdTop418].value,
          isError: currentData[switchIdTop418].errorLevel,
          isRunningTime: true,
        };
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-down: 10px;

  // & div {
  //   border: 1px solid;
  // }

  .dehumidifier-main {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 10px);

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-L {
    width: 100%;
    height: calc(55% - 7px);
    min-height: 380px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-S {
    width: 100%;
    height: calc(45% - 7px);
    min-height: 250px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-1-1 {
    width: 100%;
    height: calc(70% - 7px);
    min-height: 510px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-1-2 {
    width: 100%;
    height: calc(30% - 7px);
    min-height: 210px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-2-1 {
    width: 100%;
    height: calc(55% - 7px);
    min-height: 400px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-2-2 {
    width: 100%;
    height: calc(45% - 7px);
    min-height: 320px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-3-1 {
    width: 100%;
    height: calc(55% - 7px);
    min-height: 400px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-3-2 {
    width: 100%;
    height: calc(45% - 7px);
    min-height: 320px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-4-1 {
    width: 100%;
    height: calc(55% - 7px);
    min-height: 400px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-4-2 {
    width: 100%;
    height: calc(45% - 7px);
    min-height: 320px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-full {
    height: 100%;
    min-height: 635px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column {
    width: calc(100% / 4 - 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .main-column-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .switch-in-tooltip {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    margin-down: 5px;
  }

  .main-column-multi-line {
    width: calc(100% / 4 - 10px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-down: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item-sub-title {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-down: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-down: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .tooltip-slot {
    line-height: 1.4;
  }
}
</style>
